module.exports = __webpack_public_path__ + "static/drop-77e15a09c75fc2b1da1c900f5fa36358.png";